export default __webpack_public_path__ + "static/media/fevrtoken-prompt-coins.04e967cc.png";